/**
 * Number of worklist filters the user has actively set.
 *
 * Drives the badge on the mobile "Filters" button: below `md` the secondary
 * search inputs and filter pills collapse into a sheet, so without the badge
 * an active filter would silently constrain the list with no visible cue.
 * Date range counts as one filter regardless of which bound(s) are set.
 */
export function countActiveWorklistFilters(filters, activeQuickFilter) {
    let count = 0;
    if (filters.institutionName)
        count++;
    if (filters.referringPhysiciansName)
        count++;
    if (filters.reportKeyword)
        count++;
    if (filters.tag)
        count++;
    if (filters.modality)
        count++;
    if (filters.clinicCode)
        count++;
    if (filters.fromDateTime || filters.toDateTime)
        count++;
    if (activeQuickFilter && activeQuickFilter !== 'all')
        count++;
    return count;
}
